'use client';

import VideoPlayer from '../../VideoPlayer';
import VideoPreview from '../VideoPreview/VideoPreview';
import VideoControls from '../VideoControls/VideoControls';
import { VideoItemReference } from 'types/sharedComponents';
import { cn } from 'utils/styles';

interface FullBleedVideoPlayerProps {
  video: VideoItemReference;
  mediaHasOverlay?: boolean;
}

const FullBleedVideoPlayer = ({ video, mediaHasOverlay }: FullBleedVideoPlayerProps) => {
  return (
    <VideoPlayer
      video={video}
      autoPlay
      muted
      loop
      playInBackground
      hideNativeControls
      testId="full-bleed-video-player"
      classNames={{
        wrapper: 'w-full h-full',
        player: cn('object-cover', { 'opacity-15': mediaHasOverlay }),
      }}>
      {!mediaHasOverlay && <VideoPreview image={video.previewImage} showPreviewOnEnd={false} priority />}
      <VideoControls hideOnVideoStarted={false} />
    </VideoPlayer>
  );
};

export default FullBleedVideoPlayer;
